/** @jsxImportSource theme-ui */
import { useState } from "react";
import { Box, Button, Image, Spinner } from "theme-ui";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
}

const PhotoModal = ({ isOpen, onClose, imageUrl }: ModalProps) => {
  const [isLoading, setIsLoading] = useState(true);

  if (!isOpen) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: ["90%", "70%", "50%"], 
          maxWidth: "800px",
          maxHeight: "90vh", 
          backgroundColor: "background",
          borderRadius: "15px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {isLoading && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: ["300px", "400px"], 
            }}
          >
            <Spinner size={50} />
          </Box>
        )}
        <Box
          sx={{
            overflow: "auto", 
            width: "100%",
            height: "100%",
          }}
        >
          <Image
            src={imageUrl}
            alt="Modal Content"
            sx={{
              display: isLoading ? "none" : "block",
              maxWidth: "100%",
              maxHeight: "90vh", 
              objectFit: "contain", 
              margin: "auto",
            }}
            onLoad={() => setIsLoading(false)}
          />
        </Box>
        <Button
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            background: "error",
            color: "buttonText",
            borderRadius: "50%",
            width: 32,
            height: 32,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          ✕
        </Button>
      </Box>
    </Box>
  );
};

export default PhotoModal;